<template>
  <v-list-tile
    :key="id"
    ripple
    class="nx-primary--lighten-5"
  >

    <nx-image
      v-if="thumbnailUrl"
      class="mr-2"
      :src="thumbnailUrl"
      :alt="title"
      width="80"
      minWidth="80"
      height="80"
    ></nx-image>
     <v-list-tile-avatar v-else>
       <v-icon>{{ typeIcon }}</v-icon>
     </v-list-tile-avatar>

    <v-list-tile-content class="pr-3">
      <v-list-tile-title>{{ title }}</v-list-tile-title>
      <v-list-tile-sub-title>
        <div class="badges">
          <nx-badge>{{ type ? $tc(type, 1) : id }}</nx-badge>
          <nx-badge v-for="(badge, index) in badges" :key="index" v-bind="badge">{{ $t(badge.label) }}</nx-badge>
        </div>
      </v-list-tile-sub-title>
    </v-list-tile-content>
    <v-list-tile-action @click.stop>
      <v-layout row align-center>
        <v-menu class="ma-0" offset-y>
          <v-btn flat icon color="primary" slot="activator">
            <v-icon>more_vert</v-icon>
          </v-btn>
          <v-list>
            <v-list-tile avatar :to="route" target="_blank">
              <v-list-tile-avatar>
                <v-icon>link</v-icon>
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title>
                  {{ $t('message.list.actions.edit') }}
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile @click="$emit('delete')" avatar>
              <v-list-tile-avatar>
                <v-icon>clear</v-icon>
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title>
                {{ $t('message.list.actions.delete') }}
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-menu>
        <v-btn class="nx-sortable-handle ma-0" flat icon color="primary">
          <v-icon>drag_handle</v-icon>
        </v-btn>
      </v-layout>
    </v-list-tile-action>
  </v-list-tile>
</template>

<script>
import Image from '@/components/media/Image';
import Badge from '@/components/Badge';
import { typeToIcon } from '@/modules/content/config';

export default {
  name: 'nx-searcher-sortable-list-item',
  components: {
    [Image.name]: Image,
    [Badge.name]: Badge,
  },
  props: {
    id: {
      type: [String, Number],
      required: true,
    },
    type: {
      type: String,
    },
    title: {
      type: String,
      required: true,
    },
    thumbnailUrl: {
      type: String,
    },
    entity: {
      type: Object,
    },
    /**
     * @typedef {Object} Badge
     * @property {string} color
     * @property {string} fontColor
     * @property {string} label
     */

    /*
    * @return {Badge[]}
    */
    badges: {
      type: Array,
    },
    processing: {
      type: Boolean,
    },
    scheduled: {
      type: Boolean,
    },
    published: {
      type: Boolean,
    },
    icon: String,
  },
  computed: {
    typeIcon() {
      return this.icon || typeToIcon(this.type);
    },
    route() {
      const { type, id } = this.entity;
      if (!type) {
        return null;
      }
      return {
        name: 'content.editor',
        params: {
          id,
          type,
        },
      };
    },
  },
};
</script>

<style lang="stylus" scoped>
.nx-sortable-handle {
  cursor: move;
}
.sortable-ghost {
  opacity: 0;
}
</style>
